import { STORE_TRANSLATIONS, STORE_USER_LANGUAGE } from '../types';

const initialState = {
  language: null,
  translationsCache: [],
  lastCacheTime: null,
};

const globalizationReducer = (state = initialState, action) => {
  switch (action.type) {
  case STORE_USER_LANGUAGE:
    return {
      ...state,
      type: action.type,
      language: action.language,
    };
  case STORE_TRANSLATIONS:
    return {
      ...state,
      type: action.type,
      translationsCache: action.translationsCache,
      lastCacheTime: action.lastCacheTime,
    };
  default:
    return state;
  }
};

export default globalizationReducer;
